import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton, Typography, CircularProgress
} from "@material-ui/core";
import RTL from "../../../../components/RTL";
import mockData from "./data";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Pagination from "@material-ui/lab/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "redux/Action";
import { axios } from "./../../../../axios";
import { SearchInput } from "components";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  searchInput: {
    padding: theme.spacing(2),
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  imageInput: {
    display: "none",
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));
let filter_txt = "";

const CityList = (props) => {
  const classes = useStyles();
  const { onDelete, onInfo, ChangeId, showEdit,reload,selData ,del,edit,info} = props;

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [filter, setFilter] = React.useState("");
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const GetData = async () => {
    try {
      const res = await axios.get(`city/find?city=${filter_txt}&page=${Page}`, {
        headers: headers,
      });

      setLastPage(res.data.cities.last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData([]);

      setData(res.data.cities.data);
      dispatch(Loading()); 
    } catch (e) {
      dispatch(Loading());

      
    }

    //alert(res)
  };

  useEffect(() => {
    filter_txt="";
    dispatch(Loading());
    GetData(); 
  }, [Page,reload]);

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === "Enter") {
      filter_txt = event.target.value;
      GetData();
      dispatch(Loading());
    }
  };

  return (
    <RTL>
     

      <>
        <div className={classes.searchInput}>
          <SearchInput
            onKeyDown={handleKeyDown}
            placeholder="نام شهر مورد نظر را جستجو کنید"
          />
        </div>
        {!isLoading ? (
          <>
            {data ? (
              data.length > 0 ? (
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">استان</TableCell>
                        <TableCell align="center">شهر</TableCell>

                        <TableCell align="center" sortDirection="desc">
                          عملیات
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {data.map((dts) => (
                        <TableRow hover key={dts.id}>
                          
                          <TableCell align="center">{dts.get_province?.name}</TableCell>
                          <TableCell align="center">{dts.name}</TableCell>


                          <TableCell align="center">
            
                  <IconButton
                  
                  disabled={edit || del || info}
                  style={
                    edit || del || info
                      ? { color: "#7f8c8d" }
                      : { color: "#6c5ce7" }
                  }
                  onClick={() => {
                    showEdit();
                    ChangeId(dts.id);
                    selData(
                      data
                        .filter((dt) => dt.id == dts.id)
                        .map((filterData) => filterData)
                    );
                  }}
                                      color="error"
                    aria-label="upload picture"
                    component="span"
                  >
                    <EditIcon />
                  </IconButton>
                 
           
                </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {LastPage > 1 ? (
                    <Pagination
                      style={{ margin: 10 }}
                      variant="outlined"
                      onChange={handleChangePage}
                      page={Page}
                      count={LastPage}
                      color="primary"
                    />
                  ) : (
                    ""
                  )}
                </TableContainer>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    padding: 50,

                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                </div>
              )
            ) : (
              ""
            )}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={24} />
          </div>
        )}
      </>
    </RTL>
  );
};

export default CityList;
